import { render, staticRenderFns } from "./StatusDeliveryView.vue?vue&type=template&id=87c592a8&scoped=true&"
import script from "./StatusDeliveryView.vue?vue&type=script&lang=js&"
export * from "./StatusDeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./StatusDeliveryView.vue?vue&type=style&index=0&id=87c592a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c592a8",
  null
  
)

export default component.exports